<irembogov-navbar
  [navbarItems]="getMainNavBarLinkItemsForRole()"
  [showNotification]="false">
  <irembogov-navbar-profile-section
    profile
    [username]="
      userProfile && userProfile.firstName ? userProfile.firstName : ''
    "
    [activeRole]="
      userProfile && userProfile.primaryRole.label
        ? userProfile.primaryRole.label
        : ''
    "
    [roles]="getOtherRoles()"
    [updatedProfile]="userProfile.profileImageUrl"
    (logout)="logoutUser()"
    (profileClick)="profilePageRedirect($event)"
    (roleChange)="onRoleChange($event)"></irembogov-navbar-profile-section>
</irembogov-navbar>
